document.addEventListener('DOMContentLoaded', () => {
  const productSelectorForm = document.getElementById('productSelectorForm');
  if (!productSelectorForm) return;

  // query all the field inputs on load
  const isOrganicCheckbox = productSelectorForm.querySelector('#is_organic');
  const usdaZone = productSelectorForm.querySelector('#usda_zone');
  const garlicNeckType = productSelectorForm.querySelector('#garlic_neck_type');
  const approxHarvestPeriod = productSelectorForm.querySelector('#approx_harvest_period');
  const flavorProfile = productSelectorForm.querySelector('#flavor_profile');
  const clearButton = productSelectorForm.querySelector('#btnClearAll');

  // initialize the has-value attribute toggle for the select elements.
  // the attribute is used as a css selector. It helps decide the label placement.
  (() => {
    productSelectorForm.querySelectorAll('select').forEach((select) => {
      select.addEventListener('input', (e) => {
        e.currentTarget.setAttribute('has-value', e.currentTarget.value !== '');
      });
      select.setAttribute('has-value', select.value !== '');
    });
  })();

  // submit handler
  productSelectorForm.addEventListener('submit', (e) => {
    e.preventDefault();

    const garlicCollectionURL = new URL(
  `${window.location.origin}/collections/seed-garlic-and-shallots`
);
garlicCollectionURL.searchParams.append('sort_by', 'manual');

    // appends the field values as search parameters
    const appendSearchParams = () => {
      const isOrganic = productSelectorForm.querySelectorAll(
        'input[name="is_organic"]:not([data-all-options]):checked'
      );
      if (isOrganic.length) {
        isOrganic.forEach((checkbox) => {
          garlicCollectionURL.searchParams.append('filter.v.m.custom.organic_filter', checkbox.value);
        });
      }

      const usdaZone = productSelectorForm.querySelector('input[name="usda_zone"]:not([data-all-options]):checked');
      if (usdaZone && usdaZone.value) {
        garlicCollectionURL.searchParams.append('filter.p.m.custom.growing_zone', `${usdaZone.value}`);
      }

      const garlicTypes = productSelectorForm.querySelectorAll(
        'input[name="garlic_type"]:not([data-all-options]):checked'
      );
      if (garlicTypes.length) {
        garlicTypes.forEach((type) => {
          garlicCollectionURL.searchParams.append('filter.p.m.global.garlic_type', `${type.value}`);
        });
      }

      const garlicNeckTypes = productSelectorForm.querySelectorAll(
        'input[name="garlic_neck_type"]:not([data-all-options]):checked'
      );
      if (garlicNeckTypes) {
        garlicNeckTypes.forEach((type) => {
          garlicCollectionURL.searchParams.append('filter.p.m.custom.garlic_neck', `${type.value}`);
        });
      }

      const approxHarvestPeriod = productSelectorForm.querySelectorAll(
        'input[name="approx_harvest_period"]:not([data-all-options]):checked'
      );
      if (approxHarvestPeriod.length) {
        approxHarvestPeriod.forEach((period) => {
          garlicCollectionURL.searchParams.append('filter.p.m.global.approximate_harvest_time', `${period.value}`);
        });
      }

      const flavorProfiles = productSelectorForm.querySelectorAll(
        'input[name="flavor_profile"]:not([data-all-options]):checked'
      );
      if (flavorProfiles.length) {
        flavorProfiles.forEach((flavor) => {
          garlicCollectionURL.searchParams.append('filter.p.m.custom.flavor_profile', `${flavor.value}`);
        });
      }
    };

    appendSearchParams();

    garlicCollectionURL.searchParams.append('return_url', window.location.pathname);
    window.location = garlicCollectionURL;
  });
  clearButton.addEventListener('click', () => {
    const allInputs = productSelectorForm.querySelectorAll('input:not([data-all-options]):checked');
    allInputs.forEach((input) => {
      input.checked = false;
      input.dispatchEvent(new Event('change'));
    });
  });
});
